<template>
  <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
    <font-awesome-icon icon="plus-circle"/>&nbsp;{{ $t('buyNew') }}
    <b-modal v-model="showForm" :title="$t('buyNew')" no-close-on-backdrop no-enforce-focus size="xs">
      <div v-if="client" class="alert alert-info">
        <div><span><b>{{ $t('currentCreditBalance') }}: </b></span>{{ client.creditBalance | numFormat }}</div>
      </div>
      <client-select v-if="showForm" :label="$t('client')" :model="formModel" attribute="client"
                     :is-trial-or-not-chatbot="true" :errors="formErrors"></client-select>
      <form-input :label="$t('numberOfUser')" attribute="limit" :model="formModel"
                  :errors="formErrors"></form-input>
      <div class="mb-3">
        <div class="mb-2">{{ $t('packageExpireTime') }}</div>
        <time-picker :model="formModel" :errors="formErrors" :label="$t('endMonth')" attribute="endMonth"
                     unit="month"></time-picker>
      </div>
      <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
      <client-user-select :disabled="!formModel.client" :model="formModel" attribute="manager"
                          :label="$t('managerAccount')"
                          :client-filter="formModel.client" :place-holder="$t('selectManager')"
                          :errors="formErrors"></client-user-select>
      <hr>
      <p class="text-right"><b>{{ $t('numberOfUser') }}</b>: <span
          class="text-success">{{ formModel.limit && formModel.limit > 0 ? formModel.limit : 0 }}</span></p>
      <p class="text-right"><b>{{ $t('numberOfMonth') }}</b>: <span class="text-success">{{ monthCount }}</span></p>
      <p class="text-right"><b>{{ $t('packagePricePerMonth') }}</b>: <span class="text-success">{{
          chatbotFee | numFormat
        }}</span></p>
      <p class="text-right"><b>{{ $t('total') }}</b>: <span class="text-danger">{{ total | numFormat }}</span></p>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button
            :disabled="!total || total <= 0 || !formModel.client || !['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
            class="btn btn-primary float-right"
            @click="purchase()">
          {{ $t('savePlanOrder') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import moment from "moment";
import TimePicker from "@/components/TimePicker.vue";
import ClientUserSelect from "@/components/ClientUserSelect.vue";

export default {
  components: {ClientUserSelect, TimePicker, ClientSelect},
  props: ['chatbotFee'],
  mixins: [CRUD],
  data: function () {
    return {
      service: '/client-chatbot',
      defaultFormModel: {
        client: null,
        limit: 1,
        endMonth: moment(Date.now()).endOf('month'),
        note: null,
        manager: null,
      },
      client: null
    }
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (this.showForm && val) {
          this.updateInvoiceEnabled();
        } else {
          this.formModel.invoiceEnabled = false
          this.client = null
        }
      }
    },
  },
  methods: {
    open: function () {
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
    },
    purchase() {
      let loader = this.$loading.show();
      this.$service({url: '/client-chatbot/buy-new/', method: 'post', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('clientChatbot');
          this.showForm = false;
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    updateInvoiceEnabled() {
      this.$service.get('/client/' + this.formModel.client).then(response => {
        if (response) {
          this.formModel.invoiceEnabled = response.data.manualInvoiceEnabled
          this.client = response.data
        }
      })
    },
  },
  computed: {
    monthCount() {
      if (this.formModel.endMonth) {
        let start = moment(Date.now()).startOf('month');
        let end = moment(this.formModel.endMonth).endOf('month');
        let diff = moment(end + 1).diff(start, 'month');
        if (moment(Date.now()).date() >= 15) {
          diff -= 0.5
        }
        return diff && diff > 0 ? diff : 0
      }
      return 0
    },
    total() {
      if (this.monthCount && this.formModel.limit) {
        return this.monthCount * this.formModel.limit * this.chatbotFee
      }
      return 0
    },
  },
  i18n: {
    messages: {
      vi: {
        buyNew: 'Mua mới',
        packagePricePerMonth: 'Giá/nhân viên AI/tháng',
        numberOfUser: 'Số nhân viên AI',
        numberOfMonth: 'Số tháng',
        note: 'Ghi chú',
        total: 'Thành tiền',
        cancel: 'Huỷ',
        savePlanOrder: 'Lưu đơn hàng',
        managerAccount: 'Tài khoản quản lý',
        selectManager: 'Chọn tài khoản quản lý',
        packageExpireTime: 'Hạn sử dụng gói',
        endMonth: 'Đến hết tháng',
        currentCreditBalance: 'Số dư',
      },
      en: {
        buyNew: 'Buy new',
        packagePricePerMonth: 'Price/AI agent/month',
        numberOfUser: 'Number of AI agents',
        numberOfMonth: 'Number of months',
        note: 'Note',
        total: 'Total',
        cancel: 'Cancel',
        savePlanOrder: 'Save plan order',
        managerAccount: 'Management account',
        selectManager: 'Select management account',
        packageExpireTime: 'Package expiration time',
        endMonth: 'By the end of',
        currentCreditBalance: 'Balance',
      }
    }
  }
}
</script>